import { render, staticRenderFns } from "./DeletarItemCotacaoPedido.vue?vue&type=template&id=35cacf75"
import script from "./DeletarItemCotacaoPedido.vue?vue&type=script&lang=js"
export * from "./DeletarItemCotacaoPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports